<template>
  <div class="deadlines-page homepage-main">
    <ShareScheme />
    <SaveScheme />
    <DownloadScheme />

    <div class="grant-cards-container grants-container">
      <div class="pagination top-pag row justify-between">
        <span class="newest-heading">
          Komende deadlines
        </span>
        <q-pagination
          class="pagination-item"
          v-model="currentPage"
          color="black"
          outline
          direction-links
          :max="maxPages"
          :max-pages="6"
          boundary-numbers
          @click="goToPage(currentPage)"
        ></q-pagination>
      </div>
      <div class="cards">
        <GrantCard
          v-for="grant in grants"
          :key="grant.id"
          :title="grant.name"
          :grant="grant"
          :id="grant.id"
          :introduction="grant.introduction"
          class="card q-mt-md"
        />
      </div>
      <div class="pagination top-pag row justify-end bot-pag">
        <q-pagination
          class="pagination-item"
          v-model="currentPage"
          color="black"
          outline
          direction-links
          :max="maxPages"
          :max-pages="6"
          boundary-numbers
          @click="goToPage(currentPage)"
        ></q-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, computed, ref } from 'vue';
import SchemesUtils from '../../utils/schemes';
import store from '../../store/index';
import GrantCard from '../GrantCard.vue';
import ShareScheme from '../share-components/ShareScheme.vue';
import DownloadScheme from '../share-components/DownloadScheme.vue';
import SaveScheme from '../SaveScheme.vue';
import UserService from '../../services/userprofile.service';
export default {
  name: 'NewestSchemes',
  components: {
    GrantCard,
    ShareScheme,
    SaveScheme,
    DownloadScheme,
  },
  setup() {
    const grants = computed({
      get: () => store.state.homePageItems.grantsByDeadline,
    });

    const currentPage = computed({
      get: () => store.state.homePageItems.currentPageDeadlines,
      set: (val) =>
        store.commit('homePageItems/updateCurrentPageDeadlines', val),
    });

    const maxPages = computed({
      get: () => store.state.homePageItems.pageCountDeadlines,
    });

    const goToPage = async (page) => {
      if (!hasProfileTags.value) {
        await SchemesUtils.searchDeadlineSchemes(page - 1, 10);
      } else {
        var locationsStr = '';
        for (let i = 0; i < favoriteLocations.value.length; i++) {
          locationsStr += favoriteLocations.value[i].id + ',';
        }
        locationsStr = locationsStr.substring(0, locationsStr.length - 1);
        await SchemesUtils.searchDeadlineSchemesWithTags(
          page - 1,
          10,
          favoriteAudience.value,
          favoritePurposes.value,
          locationsStr
        );
      }
      window.scrollTo(0, 0);
    };

    onMounted(async () => {
      await UserService.getProfileConfiguration();
      await UserService.getFavoriteAudienceTags();
      await UserService.getFavoritePurposesTags();
      await UserService.getFavoriteLocationsTags();

      window.scrollTo(0, 0);
      checkForTagsUpdate();

      if (!hasProfileTags.value) {
        await SchemesUtils.searchDeadlineSchemes(0, 10);
      } else {
        var locationsStr = '';
        for (let i = 0; i < favoriteLocations.value.length; i++) {
          locationsStr += favoriteLocations.value[i].id + ',';
        }
        locationsStr = locationsStr.substring(0, locationsStr.length - 1);
        await SchemesUtils.searchDeadlineSchemesWithTags(
          0,
          10,
          favoriteAudience.value,
          favoritePurposes.value,
          locationsStr
        );
      }
    });

    const favoriteAudience = computed({
      get: () => store.state.user.favoriteAudiencesIdsArray,
    });
    const favoritePurposes = computed({
      get: () => store.state.user.favoritePurposesIdsArray,
    });
    const favoriteLocations = computed({
      get: () => store.state.user.selectedFavoriteLocations,
    });

    const hasProfileTags = ref(false);

    const checkForTagsUpdate = () => {
      if (
        favoriteAudience.value.length > 0 ||
        favoritePurposes.value.length > 0 ||
        favoriteLocations.value.length > 0
      ) {
        hasProfileTags.value = true;
      }
    };

    return {
      grants,
      currentPage,
      maxPages,
      goToPage,
      favoriteAudience,
      favoritePurposes,
      favoriteLocations,
      checkForTagsUpdate,
    };
  },
};
</script>
